<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/info' }">基本资料</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/index/info/safe'}">安全中心</el-breadcrumb-item>
            <el-breadcrumb-item>修改密码</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="form-box">
            <div class="form-title text-center">
                修改登录密码
            </div>
            <div class="form-content">
                <el-form label-width="100px">
                    <el-form-item label="原密码">
                        <el-input type="password" v-model="formItem.old_password"></el-input>
                    </el-form-item>
                    <el-form-item label="密码">
                        <el-input type="password" v-model="formItem.password" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码">
                        <el-input type="password" v-model="formItem.ck_password" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs'
import router from '@/router'
export default {
    data () {
        return {
            formItem: {
                old_password: '',
                password: '',
                ck_password: ''
            }
        }
    },
    methods: {
        submitForm () {
            if (this.formItem.old_password === '') {
                this.$message.error('请输入原密码')
            } else if (!(/^[a-zA-Z0-9_]{6,18}$/.test(this.formItem.old_password))) {
                this.$message.error('原密码由6-18位的数字、字母和_组成')
            } else if (this.formItem.password === '') {
                this.$message.error('请输入新密码')
            } else if (!(/^[a-zA-Z0-9_]{6,18}$/.test(this.formItem.password))) {
                this.$message.error('新密码由6-18位的数字、字母和_组成')
            } else if (this.formItem.ck_password !== this.formItem.password) {
                this.$message.error('两次输入的密码不一致')
            } else {
                this.$http.post('/api/user/resetpwd', qs.stringify({
                    old_password: this.formItem.old_password,
                    password: this.formItem.password,
                    ck_password: this.formItem.ck_password
                }))
                    .then(res => {
                        if (res.code === 0) {
                            this.$notify.success({
                                title: '通知',
                                message: '登录密码修改成功，请重新登录。'
                            })
                            localStorage.removeItem('USERINFO')
                            localStorage.removeItem('token')
                            router.replace('/login')
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.error(err)
                    })
            }
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/sub.scss";
</style>
